<div class="page-titles d-flex justify-content-between">
    <!-- Search -->
    <div class="">
        <ng-container *ngIf="showSearch">
            <app-search-filter [text]="selected?.searchText" (onSearch)="onSearchEvent($event)">
            </app-search-filter>
        </ng-container>
    </div>
    <!-- Filter -->
    <div>
        <div class="btn btn-link filter mobile" (click)="openFilterModal(filterModal)">
            {{filterTitle}}
        </div>

        <div ngbDropdown display="dynamic" placement="bottom-right" [autoClose]="false" #filterDropdown="ngbDropdown" class="desktop">
            <div class="btn btn-link filter" id="dropdownFilter" ngbDropdownToggle>
                {{filterTitle}}
            </div>

            <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownFilter">

                <div class="dropdown-filter-body">

                    <!-- Por Tipo (PointTransactionType) -->
                    <ul>
                        <li class="m-b-10 font-bold">
                            <span class="title">Por Tipo</span>
                        </li>
                        <!-- Todos -->
                        <li>
                            <div class="custom-checkbox checkbox-primary">
                                <input id="radio-status-all" name="radio-sorting" type="radio" [value]="0" [(ngModel)]="selected.selectedType">
                                <label class="form-control-label label-text-md" for="radio-status-all">Todos</label>
                            </div>
                        </li>
                        <!-- Puntos comprados -->
                        <li>
                            <div class="custom-checkbox checkbox-primary">
                                <input id="radio-status-11" name="radio-sorting" type="radio" [value]="1" [(ngModel)]="selected.selectedType">
                                <label class="form-control-label label-text-md" for="radio-status-11">
                                    Puntos comprados <i class="mdi mdi-arrow-down font-18 m-r-10 font-bold"></i>
                                </label>
                            </div>
                        </li>
                        <!-- Puntos gastados -->
                        <li>
                            <div class="custom-checkbox checkbox-primary">
                                <input id="radio-status-22" name="radio-sorting" type="radio" [value]="2" [(ngModel)]="selected.selectedType">
                                <label class="form-control-label label-text-md" for="radio-status-22">
                                    Puntos gastados <i class="mdi mdi-arrow-up font-18 m-r-10 font-bold"></i>
                                </label>
                            </div>
                        </li>
                        <!-- Puntos recibidos -->
                        <li>
                            <div class="custom-checkbox checkbox-primary">
                                <input id="radio-status-33" name="radio-sorting" type="radio" [value]="3" [(ngModel)]="selected.selectedType">
                                <label class="form-control-label label-text-md" for="radio-status-33">
                                    Puntos recibidos <i class="mdi mdi-arrow-left font-18 m-r-10 font-bold"></i>
                                </label>
                            </div>
                        </li>
                        <!-- Puntos enviados -->
                        <li>
                            <div class="custom-checkbox checkbox-primary">
                                <input id="radio-status-44" name="radio-sorting" type="radio" [value]="4" [(ngModel)]="selected.selectedType">
                                <label class="form-control-label label-text-md" for="radio-status-44">
                                    Puntos enviados <i class="mdi mdi-arrow-right font-18 m-r-10 font-bold"></i>
                                </label>
                            </div>
                        </li>
                    </ul>

                    <!-- Acomodar -->
                    <ul>
                        <li class="m-b-10 font-bold">
                            <span class="title">Acomodar</span>
                        </li>
                        <!-- Mas reciente a mas antiguo / Mas antiguo a mas reciente -->
                        <li>
                            <div class="custom-checkbox checkbox-primary">
                                <input id="radio-sorting-111" name="radio-sorting" type="radio" value="recent" [(ngModel)]="selected.selectedSorting">
                                <label class="form-control-label label-text-md" for="radio-sorting-111">Mas reciente a mas antiguo</label>
                            </div>
                        </li>
                        <li>
                            <div class="custom-checkbox checkbox-primary">
                                <input id="radio-sorting-222" name="radio-sorting" type="radio" value="old" [(ngModel)]="selected.selectedSorting">
                                <label class="form-control-label label-text-md" for="radio-sorting-222">Mas antiguo a mas reciente</label>
                            </div>
                        </li>
                        <!-- Mas a menos puntos disponibles / Menos a mas puntos disponibles-->
                        <li>
                            <div class="custom-checkbox checkbox-primary">
                                <input id="radio-sorting-333" name="radio-sorting" type="radio" value="reddark" [(ngModel)]="selected.selectedSorting">
                                <label class="form-control-label label-text-md" for="radio-sorting-333">Mas a menos puntos disponibles</label>
                            </div>
                        </li>
                        <li>
                            <div class="custom-checkbox checkbox-primary">
                                <input id="radio-sorting-444" name="radio-sorting" type="radio" value="bluedark" [(ngModel)]="selected.selectedSorting">
                                <label class="form-control-label label-text-md" for="radio-sorting-444">Menos a mas puntos disponibles</label>
                            </div>
                        </li>
                    </ul>

                    <!-- button submit -->
                    <div class="d-flex-center">
                        <button class="btn btn-primary m-2" (click)="$event.stopPropagation(); filterDropdown.close();">Atrás</button>
                        <button class="btn btn-outline-success m-2"
                            (click)="$event.stopPropagation(); filterDropdown.close(); onApplyFilterEvent()">Aplicar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #filterModal let-modal>
    <div class="modal-content">
        <div>
            <button class="close" (click)="modal.dismiss()">
                <i class="fa fa-times m-t-5 m-r-10"></i>
            </button>
        </div>

        <div class="modal-body">

            <!-- Por Tipo (PointTransactionType) -->
            <ul>
                <li class="m-b-10 font-bold">
                    <span class="title">Por Tipo</span>
                </li>
                <!-- Todos -->
                <li>
                    <div class="custom-checkbox checkbox-primary">
                        <input id="radio-status-all" name="radio-sorting" type="radio" [value]="0" [(ngModel)]="selected.selectedType">
                        <label class="form-control-label label-text-md" for="radio-status-all">Todos</label>
                    </div>
                </li>
                <!-- Puntos comprados -->
                <li>
                    <div class="custom-checkbox checkbox-primary">
                        <input id="radio-status-11" name="radio-sorting" type="radio" [value]="1" [(ngModel)]="selected.selectedType">
                        <label class="form-control-label label-text-md" for="radio-status-11">
                            Puntos comprados <i class="mdi mdi-arrow-down font-18 m-r-10 font-bold"></i>
                        </label>
                    </div>
                </li>
                <!-- Puntos gastados -->
                <li>
                    <div class="custom-checkbox checkbox-primary">
                        <input id="radio-status-22" name="radio-sorting" type="radio" [value]="2" [(ngModel)]="selected.selectedType">
                        <label class="form-control-label label-text-md" for="radio-status-22">
                            Puntos gastados <i class="mdi mdi-arrow-up font-18 m-r-10 font-bold"></i>
                        </label>
                    </div>
                </li>
                <!-- Puntos recibidos -->
                <li>
                    <div class="custom-checkbox checkbox-primary">
                        <input id="radio-status-33" name="radio-sorting" type="radio" [value]="3" [(ngModel)]="selected.selectedType">
                        <label class="form-control-label label-text-md" for="radio-status-33">
                            Puntos recibidos <i class="mdi mdi-arrow-left font-18 m-r-10 font-bold"></i>
                        </label>
                    </div>
                </li>
                <!-- Puntos enviados -->
                <li>
                    <div class="custom-checkbox checkbox-primary">
                        <input id="radio-status-44" name="radio-sorting" type="radio" [value]="4" [(ngModel)]="selected.selectedType">
                        <label class="form-control-label label-text-md" for="radio-status-44">
                            Puntos enviados <i class="mdi mdi-arrow-right font-18 m-r-10 font-bold"></i>
                        </label>
                    </div>
                </li>
            </ul>

            <!-- Acomodar -->
            <ul>
                <li class="m-b-10 font-bold">
                    <span class="title">Acomodar</span>
                </li>
                <!-- Mas reciente a mas antiguo / Mas antiguo a mas reciente -->
                <li>
                    <div class="custom-checkbox checkbox-primary">
                        <input id="radio-sorting-111" name="radio-sorting" type="radio" value="recent" [(ngModel)]="selected.selectedSorting">
                        <label class="form-control-label label-text-md" for="radio-sorting-111">Mas reciente a mas antiguo</label>
                    </div>
                </li>
                <li>
                    <div class="custom-checkbox checkbox-primary">
                        <input id="radio-sorting-222" name="radio-sorting" type="radio" value="old" [(ngModel)]="selected.selectedSorting">
                        <label class="form-control-label label-text-md" for="radio-sorting-222">Mas antiguo a mas reciente</label>
                    </div>
                </li>
                <!-- Mas a menos puntos disponibles / Menos a mas puntos disponibles-->
                <li>
                    <div class="custom-checkbox checkbox-primary">
                        <input id="radio-sorting-333" name="radio-sorting" type="radio" value="reddark" [(ngModel)]="selected.selectedSorting">
                        <label class="form-control-label label-text-md" for="radio-sorting-333">Mas a menos puntos disponibles</label>
                    </div>
                </li>
                <li>
                    <div class="custom-checkbox checkbox-primary">
                        <input id="radio-sorting-444" name="radio-sorting" type="radio" value="bluedark" [(ngModel)]="selected.selectedSorting">
                        <label class="form-control-label label-text-md" for="radio-sorting-444">Menos a mas puntos disponibles</label>
                    </div>
                </li>
            </ul>

            <!-- button submit -->
            <div class="d-flex-center">
                <button class="btn btn-primary m-2" (click)="modal.dismiss()">Atrás</button>
                <button class="btn btn-outline-success m-2" (click)="onApplyFilterEvent()">Aplicar</button>
            </div>
        </div>
    </div>
</ng-template>
